import DebouncedToggle from '../debounced-toggle';
import * as SearchActions from '../../state/search/search.action';

import template from './communicated-at-filter.html';

export class CommunicatedFilterController extends DebouncedToggle {
  constructor($timeout) {
    'ngInject';
    super($timeout);
    this.openCommunicated = this.openNotCommunicated = false;
  }

  $onInit() {}

  $onDestroy() {}

  get communicated() {
    return this.options.filter(option => option.group === 'Communicated');
  }

  get notCommunicated() {
    return this.options.filter(option => option.group === 'Not Communicated');
  }

  get selected() {
    const selectedOption = this.options.find(option => option._selected);
    const communicated = selectedOption && selectedOption.group === 'Communicated' ? selectedOption : null;
    const notCommunicated = selectedOption && selectedOption.group === 'Not Communicated' ? selectedOption : null;
    return {
      communicated,
      notCommunicated
    };
  }

  toggleCommunicatedAtOption(option) {
    option._selected = !option._selected;
    if (option._selected) {
      this.onSelect({option});
    } else {
      this.onDeselect({option});
    }

    this.openCommunicated = this.openNotCommunicated = false;
  }

  //click event handler to open the dropdown
  toggleCommunicated() {
    this.openCommunicated = true;
  }

  hideCommunicated() {
    this._debounceToggle()
      .then(() => (this.openCommunicated = false))
      .catch(this._ignore);
  }

  //click event handler to open the dropdown
  toggleNotCommunicated() {
    this.openNotCommunicated = true;
  }

  hideNotCommunicated() {
    this._debounceToggle()
      .then(() => (this.openNotCommunicated = false))
      .catch(this._ignore);
  }
}

export default {
  template,
  controller: CommunicatedFilterController,
  controllerAs: 'vm',
  bindings: {
    options: '<',
    onSelect: '&',
    onDeselect: '&'
  }
};
